import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { Button, Dialog } from '@vapor/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { BillF } from '../../../../../types/reservation-detail.types'
import { reduceAssignedProductions } from '../../../../../utils/bills'

export type SelectionDialogProps = {
  bills?: BillF[]
  assignedProductionIds?: string[]
  open: boolean
  onClose: (assignedProductionIds: string[]) => void
}

export function SelectionDialog({ bills, assignedProductionIds, open, onClose }: SelectionDialogProps) {
  const { t } = useTranslation()
  const openAssignedProductionIds = useMemo(() => {
    if (bills) {
      const ap = reduceAssignedProductions(bills.filter((b) => b.open)).map((ap) => ap.id)
      return ap
    }
    if (assignedProductionIds) {
      return assignedProductionIds
    }
    throw new Error('Either bills or assignedProductionIds must be provided')
  }, [bills?.length ?? 0, assignedProductionIds?.length ?? 0])

  return (
    <Dialog open={open} onClose={() => onClose([])}>
      <DialogTitle>{t('pms.booking.reservation.bills_action.create_document.dialog.title')}</DialogTitle>
      <DialogContent>{t('pms.booking.reservation.bills_action.create_document.dialog.message')}</DialogContent>
      <DialogActions>
        <Button //
          variant="outlined"
          disabled={openAssignedProductionIds.length <= 0}
          onClick={() => onClose(openAssignedProductionIds)}
        >
          {t('pms.booking.reservation.bills_action.create_document.dialog.create_all')}
        </Button>
        <Button //
          variant="contained"
          onClick={() => onClose([])}
        >
          {t('commons.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
